import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

const Container = styled(Box)`
  margin-top: ${(props) => (props.noMenuImage ? '20px' : '16px')};
  margin-bottom: 16px;
  background-color: ${(props) => (props?.backgroundColor ?? '#ffffff')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  z-index: 4;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);
`;

const MenuSection = ({
    title,
    subtitle,
    required,
    backgroundColor,
    titleColor,
    noMenuImage,
    children,
}) => {
    return (
        <Container backgroundColor={backgroundColor} noMenuImage={noMenuImage}>
            <Box
                sx={{
                    display: 'flex',
                    borderBottom: '1px solid #cccccc',
                    alignItems: 'center',
                    padding: '16px',
                    width: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Typography
                        sx={{
                            color: `${titleColor ?? '#000'} !important`,
                            fontFamily: 'Inter !important',
                            fontSize: '16px !important',
                            fontWeight: '600 !important',
                        }}
                    >
                        {title}
                    </Typography>
                    {subtitle ? (
                        <Typography
                            sx={{
                                color: `${titleColor ?? '#000'} !important`,
                                fontFamily: 'Inter !important',
                                fontSize: '14px !important',
                                fontWeight: '500 !important',
                            }}
                        >
                            {subtitle}
                        </Typography>
                    ) : null}
                </Box>
                {required ? (
                    <Box
                        ml={1}
                        px={1}
                        py={0.5}
                        sx={{
                            borderRadius: '5px',
                        }}
                    >
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'GilroyMedium !important',
                                fontSize: '14px !important',
                                textTransform: 'uppercase !important',
                            }}
                        >
                            required
                        </Typography>
                    </Box>
                ) : null}
            </Box>

            <Box sx={{ p: 2 }}>
                {children}
            </Box>
        </Container>
    );
};

export default MenuSection;
